<template>
    <el-card class="allot_card">
        <div slot="header" class="clearfix">
            <span>可分配用户列表</span>
        </div>
        <div class="resourseContent">
                <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                :row-style="grayRow"
                border
                height="460"
                fit
                style="width: 100%">
                <el-table-column
                    prop="code"
                    header-align="center"
                    min-width="95"
                    label="编号">
                </el-table-column>
                <el-table-column
                    prop="loginAccount"
                    header-align="center"
                    min-width="100"
                    label="登录账号">
                </el-table-column>
                 <el-table-column
                    prop="accountLevel"
                    header-align="center"
                    min-width="100"
                    label="账号级别">
                    <template scope="scope">
                        <span v-if="scope.row.accountLevel==0">超级管理员</span>
                        <span v-if="scope.row.accountLevel==1">管理员</span>
                        <span v-if="scope.row.accountLevel==2">设备主</span>
                        <span v-if="scope.row.accountLevel==3">维护人员</span>
                        <span v-if="scope.row.accountLevel==4">商户</span>
                        <span v-if="scope.row.accountLevel==5">销售</span>
                    </template>
                </el-table-column>
                 <el-table-column
                    prop="linkMan"
                    header-align="center"
                    min-width="100"
                    label="联系人">
                </el-table-column>
                 <el-table-column
                    prop="linkTel"
                    header-align="center"
                    min-width="100"
                    label="联系电话">
                </el-table-column>
                 <el-table-column
                    prop="status"
                    header-align="center"
                    min-width="100"
                    label="状态">
                    <template scope="scope">
                        <el-tag :type="scope.row.status === '已销户' ? 'danger' : 'success'"
                        close-transition>{{scope.row.status}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="100"
                    label="分配设备">>
                    <template scope="scope">
                        <el-button type="text" size="small" @click="allotTo(scope.row.code,scope.row.accountLevel)" :disabled="scope.row.accountLevel!==theType">分配设备给他</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
            <div class="table_pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNo"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal">
                </el-pagination>
            </div>
    </el-card>
</template>

<script>
    import $axios from '../../https/config'
    export default {
      props: ['deviceList', 'theType'],
      data () {
        return {
          deviceData: [],
          itemSelect: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          table_loading: false,
          adResSelectList: [],
          allotDialogShow: false
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryItemDataList(this.pageNo, this.pageSize)
      },
      methods: {
        queryItemDataList (tPageNo, tPageSize, tttt) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize
          }
          this.table_loading = true
          $axios.get('/custom/getList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    code: itemData.id,
                    loginAccount: itemData.user_name,
                    accountLevel: itemData.user_type,
                    linkMan: itemData.nickName,
                    linkTel: itemData.user_name,
                    status: itemData.status === 0 ? '正常' : '已销户',
                    pager: itemData.paperNum,
                    paperVolume: itemData.paperVolume
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
              _this.table_loading = false
            } else {
            }
          })
        },
        grayRow (row, rowIndex) {
          if (row.accountLevel !== this.theType) {
            return 'color:#bbb'
          }
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryItemDataList(this.pageNo, this.pageSize, '')
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryItemDataList(this.pageNo, this.pageSize, '')
        },
        allotTo (code, accountLevel) {
          var that = this
          var deviceCode = ''
          for (var i = 0; i < that.deviceList.length; i++) {
            deviceCode += that.deviceList[i].id + '|'
          }
          var params = {
            deviceId: deviceCode,
            userId: code
          }
          if (accountLevel === 3) {
            $axios.get('/device/assignedDeviceOperation', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                that.$message({
                  message: '分配设备运维成功',
                  type: 'success'
                })
              } else {
              }
            })
          } else if (accountLevel === 4) {
            $axios.get('/device/assignedDeviceMerchant', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                that.$message({
                  message: '分配设备商户成功',
                  type: 'success'
                })
              } else {
              }
            })
          } else if (accountLevel === 5) {
            $axios.get('/device/assignedDeviceBD', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                that.$message({
                  message: '分配设备销售成功',
                  type: 'success'
                })
              } else {
              }
            })
          }
        }
      }
    }
</script>

<style lang="scss">
    .allot_card {
        margin: 10px;
        position: relative;
        overflow-y: auto;
        height: 85%;

        .el-card__header {
            padding: 10px;
        }
        .el-card__body {
            padding: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/deviceMgr/allotAdSale.vue